import { useQuery } from "@tanstack/react-query";
import { GET_FAMILY_INFO } from "../querykeys";
import { request } from "../api";
import { BaseResponse } from "../types/baseRespones";
import { User } from "src/types/User";

export const useFamilyRegister = () => {
  return useQuery({
    queryKey: [GET_FAMILY_INFO],
    queryFn: async () => {
      const result = await request<BaseResponse<User[]>>({
        method: "GET",
        url: "/users/family",
      });
      return result.response || [];
    },
  });
};
